(function(){
  var V=JSON.parse((document.currentScript&&document.currentScript.getAttribute("data-v"))||"{}"),co=V.co,id=V.id,bridge=false,inflight=null,tEl=null,tT=0;
  function T(k,d){return typeof ssT==="function"?ssT(k,d):d}
  function frameWin(){var f=document.getElementById("content");return f&&f.contentWindow}
  function toast(t,ms){
    if(!tEl){tEl=document.createElement("div");tEl.className="ver-toast";tEl.setAttribute("role","status");document.body.appendChild(tEl)}
    tEl.textContent=t;tEl.classList.add("on");clearTimeout(tT);
    if(ms)tT=setTimeout(function(){tEl.classList.remove("on")},ms);
  }
  // The space's PDF as a saved file. One at a time: a second press while the server
  // renders gets the same promise. {quiet} leaves the saying to the caller (the menu
  // row says it in place).
  window.ssPdf=function(o){
    o=o||{};
    if(inflight)return inflight;
    var t0=Date.now(),via=o.via||"menu";
    function track(ok){if(window.mixpanel)try{mixpanel.track("Space Downloaded",{space_id:id,format:"pdf",ok:ok,ms:Date.now()-t0,via:via})}catch(x){}}
    if(!o.quiet)toast(T("viewer.preparing_pdf","Preparing PDF…"));
    inflight=fetch("/space/"+encodeURIComponent(id)+"/pdf?download=1",{credentials:"same-origin"}).then(function(r){
      if(!r.ok)return r.text().then(function(t){throw new Error(t||("HTTP "+r.status))});
      var m=/filename="([^"]+)"/.exec(r.headers.get("content-disposition")||"");
      return r.blob().then(function(b){
        var u=URL.createObjectURL(b),a=document.createElement("a");
        a.href=u;a.download=m?m[1]:"document.pdf";document.body.appendChild(a);a.click();a.remove();
        setTimeout(function(){URL.revokeObjectURL(u)},60000);
      });
    }).then(function(){
      track(true);inflight=null;
      if(!o.quiet&&tEl)tEl.classList.remove("on");
    },function(e){
      track(false);inflight=null;
      if(!o.quiet)toast(T("viewer.pdf_failed","Couldn’t make the PDF"),6000);
      throw e;
    });
    return inflight;
  };
  window.addEventListener("message",function(e){
    if(e.origin!==co||!e.data)return;
    if(e.data.type==="ss-print-ready")bridge=true;
    if(e.data.type==="ss-pdf"&&e.source&&e.source===frameWin()){
      if(navigator.userActivation&&!navigator.userActivation.isActive)return;
      window.ssPdf({via:"page"}).catch(function(){});
    }
  });
  // Ask rather than wait: the frame's own announcement can arrive before this
  // listener exists, and a missed handshake means Ctrl+P silently prints the
  // shell (chrome-free, but clipped to one page) instead of the document.
  function hello(){
    var w=frameWin();
    if(w){try{w.postMessage({type:"ss-print-hello"},co)}catch(e){}}
  }
  var frame=document.getElementById("content");
  // Re-ask after every (re)load — a version pin or a post-edit refresh swaps the document.
  if(frame)frame.addEventListener("load",function(){bridge=false;hello()});
  hello();
  document.addEventListener("keydown",function(e){
    if(!(e.metaKey||e.ctrlKey)||e.shiftKey||e.altKey)return;
    if(e.key!=="p"&&e.key!=="P")return;
    if(!bridge)return;
    e.preventDefault();
    window.ssPdf({via:"keys"}).catch(function(){});
  });
})();